export default __webpack_public_path__ + "87cf249351d92194094db54503574a0a.png";